import GeneralServices from "./GeneralServices";
import {
  IGetInsurancePremiumPortfolioResponseOk,
  IGetDashboardServices,
  IGetHiringsResponseOk,
  IGetSimulationsResponseOk,
  IResponseError,
  IGetDashboardRenewals,
  IGetUpcomingRenewalsOk,
  IGetUpcomingRenewalDocOk,
  IGetDashboardEiacFilesCount,
  IGetEiacFilesCountOK,
  IGetDashboardUnpaidInvoices,
  IGetUnpaidInvoicesOK,
} from "./ClientsDashboardServices.dto";
import { CatchErrorType } from "./dto/response/CommonResponse.dto";

class ClientsDashboardServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;
    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getSimulations = async ({
    loader,
    setLoading,
    from,
    to,
    mediatorCode,
  }: IGetDashboardServices): Promise<IGetSimulationsResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/simulations?mediatorCode=${mediatorCode}&from=${from}&to=${to}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de datos de las simulaciones.");
    }
  };

  getHirings = async ({
    loader,
    setLoading,
    from,
    to,
    mediatorCode,
  }: IGetDashboardServices): Promise<IGetHiringsResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/hiring-requests?mediatorCode=${mediatorCode}&from=${from}&to=${to}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de datos da las contrataciones.");
    }
  };

  getInsurancePremiumPortfolio = async ({
    loader,
    setLoading,
    from,
    to,
    mediatorCode,
  }: IGetDashboardServices): Promise<IGetInsurancePremiumPortfolioResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/getInsurancePremiumData?mediatorCode=${mediatorCode}&from=${from}&to=${to}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de datos de las carteras (primas).");
    }
  };

  getUpcomingRenewals = async ({
    loader,
    setLoading,
    mediatorCode,
  }: IGetDashboardRenewals): Promise<IGetUpcomingRenewalsOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/getUpcomingRenewals?mediatorCode=${mediatorCode}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de datos de pólizas en renovación");
    }
  };

  downloadUpcomingRenewals = async ({
    loader,
    setLoading,
    mediatorCode,
  }: IGetDashboardRenewals): Promise<IGetUpcomingRenewalDocOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/download-upcoming-renewal-details?mediatorCode=${mediatorCode}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación del documento de pólizas en renovación."
      );
    }
  };

  getEiacFilesCount = async ({
    loader,
    setLoading,
    from,
    to,
    mediatorCode,
  }: IGetDashboardEiacFilesCount): Promise<IGetEiacFilesCountOK | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/getEIACFilescount?mediatorCode=${mediatorCode}&from=${from}&to=${to}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de los datos de los Ficheros EIAC.");
    }
  };

  getUnpaidInvoices = async ({
    loader,
    setLoading,
    mediatorCode,
  }: IGetDashboardUnpaidInvoices): Promise<IGetUnpaidInvoicesOK | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/getUnpaidReceipts?mediatorCode=${mediatorCode}`,
      });

      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación de los datos de los recibos impagados."
      );
    }
  };

  downloadUnpaidDoc = async ({
    loader,
    setLoading,
    mediatorCode,
  }: any): Promise<any | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `dashboard/download-unpaid-receipts-detail?mediatorCode=${mediatorCode}`,
      })
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación del documento de recibos impagados."
      );
    }
  };
}

export default new ClientsDashboardServices();
